import React from 'react'
import { useWatch } from 'react-hook-form'
import { useSelector } from 'react-redux'

//UI

import { CreatableSelect, Input, Select } from '@/components/Form'
import { Flex, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'

//Hooks
import { Card } from '@/components/Elements'
import { useGCKCode } from '@/features/GCKCodes/useGCKCode'
import { offerBookingGroupPolicyType } from '@/features/offers/constants/offerEditRights/offerBookingEditRights'
import { selectOfferPermissions } from '@/features/offers/slices/offerDetail.slice'

const BookingSubSystemForm = ({ index, disabled, canEditWBSNumber }) => {
  const profitCenter = useWatch({ name: `subSystems.${index}.profitCenter` })

  const { useGCKCodeOptions } = useGCKCode()

  const { data: GCKOptions } = useGCKCodeOptions({
    valueKey: '_id',
    labelKey: 'description',
    profitCenter: profitCenter?.profitCenterCode || '',
  })

  return (
    <Flex gap={2} direction={'column'}>
      <Input
        name={`subSystems.${index}.bookingWBSNumber`}
        label="WBS Number (Input by BA)"
        type="text"
        disabled={!canEditWBSNumber}
        isRequired={false}
        isRow
      />
      <Select
        name={`subSystems.${index}.GCKCode`}
        label="GCK Code"
        disabled={disabled}
        isRequired={false}
        options={GCKOptions}
        isRow
      />
      <CreatableSelect
        name={`subSystems.${index}.SLA.equipments`}
        label={`Equipment IDs`}
        isRow
        isRequired={false}
        disabled={disabled}
      />
    </Flex>
  )
}

const BookingSubSystemSection = () => {
  const subSystems = useWatch({ name: 'subSystems' })
  const offerPermissions = useSelector(selectOfferPermissions)
  const canEditBookingSubSystem = offerPermissions[offerBookingGroupPolicyType.BOOKING_SUB_SYSTEM]?.edit ?? false
  const canEditWBSNumber = offerPermissions[offerBookingGroupPolicyType.BOOKING_WBS_NUMBER]?.edit ?? false
  return (
    <Card title="SubSystem">
      <Tabs size="md" variant="enclosed">
        <TabList>
          {subSystems.map((_, index) => (
            <Tab key={'bookingSubSystemTab_' + index}>Sub System {index + 1}</Tab>
          ))}
        </TabList>
        <TabPanels>
          {subSystems.map((_, index) => (
            <TabPanel key={'bookingSubSystemPanel_' + index}>
              <BookingSubSystemForm
                index={index}
                disabled={!canEditBookingSubSystem}
                canEditWBSNumber={canEditWBSNumber}
              />
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Card>
  )
}

export default BookingSubSystemSection
